import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const lineKey = (productId, opts = {}) => {
  const parts = [productId, opts.customization || "", opts.eggless ? "egg" : "", opts.customName || ""];
  return parts.join("::");
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("nbh_cart")) || [];
      return raw.map((i) => ({ ...i, key: i.key || lineKey(i.product_id, { customization: i.customization }) }));
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("nbh_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, opts = {}) => {
    const customization = opts.customization || null;
    const eggless = !!opts.eggless;
    const customName = (opts.customName || "").trim();
    const key = lineKey(product.id, { customization, eggless, customName });
    const extra = (customization ? 100 : 0) + (eggless ? 150 : 0);
    let label = product.name;
    if (customization) label += ` (Customized: ${customization})`;
    if (eggless) label += " (Eggless +₹150)";
    if (customName) label += ` — Name: ${customName}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + quantity } : i));
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          name: label,
          price: product.price + extra,
          weight: product.weight,
          weight_grams: product.weight_grams || 0,
          image: product.image,
          quantity,
          customization: customization || null,
          eggless,
          custom_name: customName || null,
        },
      ];
    });
  };

  const setQty = (key, quantity) => {
    if (quantity < 1) return;
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));

  const clearCart = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const grams = items.reduce((s, i) => s + (i.weight_grams || 0) * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, setQty, removeItem, clearCart, subtotal, count, grams }}
    >
      {children}
    </CartContext.Provider>
  );
};
